import React, { useMemo } from 'react';
import Badge from '../base/Badge'; // ajustează path-ul dacă e altul la tine
import AdvanceTable from '../base/AdvanceTable';
import AdvanceTableProvider, {
  useAdvanceTableContext
} from '../../providers/AdvanceTableProvider';
import AdvanceTableFooter from '../base/AdvanceTableFooter';
import useAdvanceTable from '../../hooks/useAdvanceTable';
import { Bars } from 'react-loader-spinner';

import { useBobinsState } from '../../features/bobins/hooks/useBobinsState.js';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import FilterTab from '../common/FilterTab.js';

const ProjectBobinStateTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />

      <AdvanceTableFooter pagination />
    </div>
  );
};

export default ProjectBobinStateTable;
